import getPosition from '../../helpers/getPosition';
import Lenis from '../../helpers/Lenis'
import isMobile from '../../helpers/isMobile';


export default class ScrollObject extends HTMLElement {

    constructor() {

        super();

        this.intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((el)=>{
                if (el.isIntersecting) {
                    el.target.classList.add('in-view')
                }
                else {
                    // el.target.classList.remove('in-view')
                }
            });
        });
        
        const noScale  = this.hasAttribute('no-scale')
        const parallax = this.hasAttribute('parallax');
        const offset   = Number(this.getAttribute('offset'))
        const ratio    = Number(this.getAttribute('ratio')) || 0.1

        this.data  = {
            darkTheme: false, 
            parallax,
            noScale, ratio, offset, 
            winH: 0, top: 0, left: 0, 
            width: 0, height: 0,
        }

        // this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.update   = this.update.bind(this);
        this._scrollTop  = 0;
    }

    onScroll(scroll) {
        this._scrollTop = scroll

        let {top, height, noScale, ratio, offset, winH} = this.data

        this.setAttribute('height', height)
        this.setAttribute('ratio', ratio)
        this.setAttribute('winH', winH)
        this.setAttribute('offset', offset)
        this.setAttribute('scroll', this._scrollTop)

        // if ( top - this._scrollTop < winH) {
            let r = (top - (this._scrollTop) + height + offset*winH) / (winH + height)
            // r = Math.min(1, Math.max(0, r))
            
            this.style.transform = `translateY(${ (r-0.5) * 2 * height * ratio }px) scale(${noScale?'1':'1.2'}) translateZ(0)`


        // }
    }

    connectedCallback() {

        this.isAttached = true

        if (this.data.parallax && !isMobile()) {
            // document.addEventListener('scroll', this.onScroll);
            Lenis.on('scroll', e => {
                this.onScroll( e.animatedScroll )
            });
            window.addEventListener('resize',   this.onResize);
            this.resizeObserver = new ResizeObserver(e => {
                this.onResize()
            });
            this.resizeObserver.observe(this);
            this.resizeObserver.observe(document.body);
            this.onScroll( 0 )
            this.update();
        }

        this.intersectionObserver.observe(this);

    }

    disconnectedCallback() {
        this.isAttached = false
        this.intersectionObserver.unobserve(this);
        if (this.data.parallax && !isMobile()) {
            // document.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize',   this.onResize);
            this.resizeObserver.unobserve(this);
            this.resizeObserver.unobserve(document.body);
        }
    }
    // onScroll(e) {
    //     this._scrollTop = window.pageYOffset
    // }
    onResize() {

        if (this.data.parallax && !isMobile()) {
            let {top, left, width, height} = getPosition(this)
            this.data.top    = top;
            this.data.left   = left;
            this.data.width  = width;
            this.data.height = height;
            this.data.winH   = window.innerHeight;
        }
    }
    update() {

        if (!this.isAttached) {
            return
        }
        requestAnimationFrame(this.update);

        // if (this.data.parallax) {
        //     let {top, height, noScale, ratio, offset, winH} = this.data

        //     this.setAttribute('height', height)
        //     this.setAttribute('ratio', ratio)
        //     this.setAttribute('winH', winH)
        //     this.setAttribute('offset', offset)
        //     this.setAttribute('noScale', noScale)
        //     this.setAttribute('scroll', this._scrollTop)

        //     // if ( top - this._scrollTop < winH) {
        //         let r = (top - (this._scrollTop) + height + offset*winH) / (winH + height)
        //         // r = Math.min(1, Math.max(0, r))
        //         this.style.transform = `translateY(${ (r-0.5) * 2 * height * ratio }px) scale(${noScale?'1':'1.2'}) translateZ(0)`
        //     // }
        // }

        
    }
}
customElements.define('scroll-object', ScrollObject);